/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { httpService } from "../../../../services";
import { HTTP_METHOD } from "@nf/constants";
import {
  IUserSubprofilePinCodeRequestModel,
  IUserSubprofilePinCodeResponseModel,
} from "../models";

export class UserSubprofilesPinCodeService {
  get url(): string {
    return `/v3/user/pincode`;
  }

  public getPinCode = (): Promise<IUserSubprofilePinCodeResponseModel[]> =>
    httpService.request<IUserSubprofilePinCodeResponseModel[]>({
      method: HTTP_METHOD.GET,
      url: `${this.url}`,
    });

  public setPinCode = (
    request: IUserSubprofilePinCodeRequestModel,
    pinCodeId?: string
  ): Promise<IUserSubprofilePinCodeResponseModel[]> =>
    httpService.request<IUserSubprofilePinCodeResponseModel[]>({
      method: pinCodeId ? HTTP_METHOD.PUT : HTTP_METHOD.POST,
      url: pinCodeId ? `${this.url}/pin/${pinCodeId}` : `${this.url}`,
      data: request,
    });

  public deletePinCode = (pinCodeId?: string): Promise<void> =>
    httpService.request<void>({
      method: HTTP_METHOD.DELETE,
      url: `${this.url}/pin/${pinCodeId}`,
    });

  public validatePinCode = (
    pinCodeId: string,
    data: { inClear: string }
  ): Promise<string[]> =>
    httpService.request<string[]>({
      method: HTTP_METHOD.POST,
      data,
      url: `${this.url}/pin/${pinCodeId}/validate`,
    });
}
